import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "../lib/api";
import { useMarket } from "../lib/store";
import { ExTag } from "./Price";

export function InstrumentPicker({ onPick }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const addMeta = useMarket((s) => s.addMeta);
  useEffect(() => {
    if (q.trim().length < 2) { setRows([]); return undefined; }
    const t = setTimeout(() => api.get("/instruments/search", { params: { q } }).then((r) => setRows(r.data.slice(0, 8))).catch(() => {}), 200);
    return () => clearTimeout(t);
  }, [q]);
  const pick = (r) => { addMeta({ [r.instrument_key]: r }); onPick(r.instrument_key); };
  return (
    <div data-testid="instrument-picker">
      <div className="flex items-center gap-2 h-9 px-2.5 rounded-md border border-input bg-background focus-within:border-primary">
        <Search className="h-3.5 w-3.5 text-muted-foreground" />
        <input data-testid="instrument-picker-input" autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search a stock, future or option…"
          className="flex-1 bg-transparent outline-none text-[13px]" />
      </div>
      <div className="mt-1 max-h-64 overflow-auto thin-scroll">
        {rows.map((r) => (
          <button key={r.instrument_key} data-testid={`instrument-picker-option-${r.trading_symbol}`} onClick={() => pick(r)}
            className="w-full flex items-center justify-between gap-2 px-2 py-2 rounded hover:bg-accent text-left transition-colors duration-150">
            <span className="min-w-0"><span className="text-[12.5px] font-medium block truncate">{r.trading_symbol}</span>
              <span className="text-[10.5px] text-muted-foreground truncate block">{r.name}</span></span>
            <ExTag ex={r.exchange} />
          </button>
        ))}
        {q.trim().length >= 2 && !rows.length && <div className="px-2 py-3 text-[12px] text-muted-foreground">No matches</div>}
      </div>
    </div>
  );
}
